import { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

/**
 * RichEditor — Editor de texto moderno tipo correo / Word.
 *
 * Soporta: negritas, cursivas, subrayado, tachado, colores de texto/fondo,
 * encabezados H1-H6 (temas, subtemas, sub-sub-temas), listas con sangría
 * de múltiples niveles, citas, alineación, enlaces, undo/redo.
 *
 * El valor se guarda como HTML.
 *
 * Props:
 *  - value: string HTML
 *  - onChange: (html) => void
 *  - placeholder
 *  - height (default 280)
 */
const TOOLBAR = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ align: [] }],
  ["blockquote", "code-block"],
  ["link"],
  ["clean"],
];

const FORMATS = [
  "header", "bold", "italic", "underline", "strike",
  "color", "background",
  "list", "indent", "align",
  "blockquote", "code-block",
  "link",
];

export default function RichEditor({ value, onChange, placeholder = "", height = 260 }) {
  const modules = useMemo(() => ({
    toolbar: TOOLBAR,
    clipboard: { matchVisual: false },
  }), []);

  return (
    <div className="rich-editor-wrap" data-testid="rich-editor">
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
        style={{ height, marginBottom: 42 }}
      />
    </div>
  );
}

/**
 * Renderer de HTML guardado (vista no-edit).
 */
export function RichView({ html, empty = "Sin contenido." }) {
  if (!html || !html.replace(/<[^>]+>/g, "").trim()) {
    return <div className="text-slate-400 text-sm">{empty}</div>;
  }
  return (
    <div
      className="rich-view prose prose-slate max-w-none text-sm"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
